import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, Sparkles } from 'lucide-react';
const formulaSteps = [{
  letter: 'A',
  title: 'Atraer',
  description: 'Llevamos clientes ideales a tu página web con Meta Ads.',
  color: 'from-purple-500 to-purple-700',
  glow: 'shadow-[0_0_30px_rgba(168,85,247,0.4)]',
  textColor: 'text-purple-400'
}, {
  letter: 'E',
  title: 'Explicar',
  description: 'Tu página muestra tus servicios y genera confianza.',
  color: 'from-pink-500 to-pink-700',
  glow: 'shadow-[0_0_30px_rgba(236,72,153,0.4)]',
  textColor: 'text-pink-400'
}, {
  letter: 'Z',
  title: 'Cerrar',
  description: 'El cliente te escribe por WhatsApp listo para contratar.',
  color: 'from-green-400 to-green-600',
  glow: 'shadow-[0_0_40px_rgba(74,222,128,0.5)]',
  textColor: 'text-green-400',
  isWhatsApp: true
}];
export function FormulaSection() {
  return <section className="py-24 bg-[#0a0a1a] relative overflow-hidden border-y border-white/5" data-id="element-145">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-146"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-purple-900/10 rounded-full blur-[120px] pointer-events-none" data-id="element-147" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-148">
        <div className="text-center mb-20" data-id="element-149">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/20 text-purple-300 text-sm font-medium mb-6" data-id="element-150">
            <Sparkles className="w-4 h-4" data-id="element-151" />
            Nuestra Fórmula Comprobada
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-bold font-orbitron mb-6" data-id="element-152">
            El Método <span className="text-gradient-cosmic" data-id="element-153">A-Z</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl text-gray-300 font-medium max-w-2xl mx-auto" data-id="element-154">
            Todo el camino hasta el{' '}
            <span className="text-green-400 font-bold" data-id="element-155">WhatsApp</span>.
          </motion.p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-156">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-24 left-[10%] right-[10%] h-1 bg-gradient-to-r from-purple-500 via-pink-500 to-green-500 opacity-30 rounded-full" data-id="element-157" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-158">
            {formulaSteps.map((step, index) => <motion.div key={step.letter} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center group" data-id="element-159">
                {/* Letter Circle */}
                <div className={`w-32 h-32 md:w-40 md:h-40 rounded-full bg-gradient-to-br ${step.color} p-[2px] mb-8 ${step.glow} transition-transform duration-500 group-hover:scale-110 group-hover:-translate-y-2`} data-id="element-160">
                  <div className="w-full h-full bg-[#050510] rounded-full flex items-center justify-center relative overflow-hidden" data-id="element-161">
                    <div className={`absolute inset-0 bg-gradient-to-br ${step.color} opacity-20`} data-id="element-162" />
                    <span className="text-6xl md:text-7xl font-bold font-orbitron text-white relative z-10" data-id="element-163">
                      {step.letter}
                    </span>
                    {step.isWhatsApp && <MessageCircle className="absolute bottom-4 right-4 w-8 h-8 text-green-400 animate-pulse" data-id="element-164" />}
                  </div>
                </div>

                {/* Content */}
                <div className="bg-[#050510]/50 backdrop-blur-sm border border-white/5 rounded-2xl p-6 w-full relative" data-id="element-165">
                  {/* Arrow for mobile (between cards) */}
                  {index < formulaSteps.length - 1 && <div className="md:hidden absolute -bottom-10 left-1/2 -translate-x-1/2 text-gray-600" data-id="element-166">
                      <ArrowRight className="w-6 h-6 rotate-90" data-id="element-167" />
                    </div>}

                  <h3 className={`text-2xl font-bold font-orbitron mb-3 ${step.textColor}`} data-id="element-168">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed" data-id="element-169">
                    {step.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}